import React,{useState, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {Box,Collapse,IconButton,Paper,Table,TableBody,TableCell, Tooltip,
        TableContainer,TableHead,TableRow,Backdrop} from '@material-ui/core';
import axios from 'axios';
import qs from 'qs';
import { useHistory } from "react-router-dom";
import Viewer from 'react-viewer';
import moment from 'moment';
import ModBitacora from './ModBitacora';
import {llamaApiCargaToken,ErrorGeneral } from '../funciones/ClienteAxios';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import CircularProgress from '@material-ui/core/CircularProgress';
import ModEdit from './ModalEditar';
import CreateIcon from '@material-ui/icons/Create';

const useStyles = makeStyles((theme)=>({
  root: {
    width: '100%',
  },  
  backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  container: {
    //maxHeight: 550,
    maxHeight: window.innerHeight-480,
    minHeight: 190,
    minWidth:'100%',
  },
  container2: {
    maxHeight: 550,
    //maxHeight: window.innerHeight-170,
    //minHeight: 280,
  },
  tableRow: {
    "&$selected, &$selected:hover": {
      backgroundColor: process.env.REACT_APP_COLOR
    }
  },
  tableCell: {
    "$selected &": {
      color: "white"
    }
  },
  hover: {},
  selected: {}
}));

const columnas=[      
   /*      
    {
      Id:3,
      titulo:"Estatus",
      alineacion:'center' 
    }, */        
    {
      Id:1,
      titulo:"Orden",
      alineacion:'center'
    },
    {
      Id:2,
      titulo:"Tipo",
      alineacion:'center'
    },
    {
      Id:3,
      titulo:"Fecha de Inicio",
      alineacion:'center'
    },
    {
      Id:7,
      titulo:"Fecha Mtto",
      alineacion:'center'
    },
    { Id:4,
      titulo:"Tiempo Vida",
      alineacion:'center'
    },    
    { Id:5,
      titulo:"Horas Uso",
      alineacion:'center'
    },    
    { Id:6,
      titulo:"Vueltas",
      alineacion:'center'
    },    
    { Id:8,
      titulo:"Técnico",
      alineacion:'center'
    },    
  ]

export default function TablaPilonaDetalle({listDet, piezaRegis, setPiezaRegis, cambiaColor, setEngRegis, cambiaColor2, engRegis, piloRegistro}) {
  const classes = useStyles();
  let history = useHistory();
  let nvlSNPermiso ='5'      
  const idusu= localStorage.getItem('UsuId');  
  const source = axios.CancelToken.source();       
  const [registro, setRegistro] = useState([]);
  const [open, setOpen] = useState(false);     
  const [espera,setEspera]=useState(false);    
  const [modalBitacora, setModalBitacora] = useState(false);  
  const [modalEdit, setModalEdit] = useState(false);  
  const [datos, setDatos] = useState([])    
  const [listImg, setListImg] = useState([])    
  const [verImg, setVerImg] = useState(false)
  const [esperaImg, setEsperaImg] = useState(false)

  useEffect(()=>{ 
    setDatos(listDet)
    //console.log(listDet);
     setRegistro([])
    return ()=> {
      source.cancel();
    }                
   
  },[ listDet]);
   
  useEffect(()=>{         
    if (piezaRegis.length !== 0 ) 
    {      
      if (piezaRegis.Id!==registro.Id) {   
        setRegistro(piezaRegis)
      }      
    }                   
   
  },[ piezaRegis]);  

  useEffect(()=>{         
    if (engRegis.length !== 0 ) 
    {      
      if (engRegis.Id!==registro.Id) {   
        setRegistro(engRegis)
      }      
    }                   
   
  },[ engRegis]);   
  
  const seleccionado=(aux, )=>{    
    
    setRegistro(aux)
    if (aux.Clase === "rodillo") {
      setPiezaRegis(aux)    
      cambiaColor({Id: aux.Ord})
      setEngRegis([])
    }
    else{
      setEngRegis(aux)
      cambiaColor2({Id: aux.Ord})
      setPiezaRegis([])    
    }
  }

  const getListImg=(idBit)=>{      
      
    const data = qs.stringify({    
      Usuario:idusu,  
      Balancin:idBit,        
      idDispositivo:'89y7gttvjhj98h'
    });
    const url = "/pilona/balancin/evidencia";
    function respuestaListTabla(aux) {
      if (aux[0].Id !== -1) 
      {                                                                  
        setListImg(aux)   
        setVerImg(true)
 
      }
      else
      { setListImg([])        
      }           
    }

    llamaApiCargaToken(data, url,respuestaListTabla, ErrorGeneral, setEsperaImg, history, source);
  } 
  

  const abrirImg=( row)=>{   
    getListImg(row.Id)    
  }   

  const celda = (alinear, estilo, contenido) => {
    return (
      <TableCell
        align={alinear} className={classes.tableCell}
        padding={"none"} style={estilo}
      >
        {contenido}
      </TableCell>
    );
  }; 
 
const celdaVacia=<TableCell align="center" padding={'none'}></TableCell> 

function Row(props) {
  const { row } = props;  
  const fecha = moment.utc(row.RodFchini);  
  const modificada= fecha.local(true).format("DD/MM/YYYY HH:mm");  
  const fecha2 = moment.utc(row.FMtto);  
  const modificada2= row.FMtto!=="1900-01-01T00:00:00.000Z"? fecha2.local(true).format("DD/MM/YYYY HH:mm"):"";  
  const auxColor= registro?.Id=== row.Id ? "white":process.env.REACT_APP_COLOR_SEC
  return (
    <React.Fragment>
      <TableRow onClick={ () => { seleccionado(row); } }
        className={classes.tableRow} selected={ registro?.Id === row.Id}
        classes={{ hover: classes.hover, selected: classes.selected }}        
      >  
        {/* row.LadoAObserv!==""|| row.LadoBObserv !==""  ? <IconoCol row={row} />:celdaVacia */} 
        {celda("center",{fontWeight:700,width:30+'px'}, 
          <Tooltip title={'Editar'}>
            <IconButton color={auxColor==="white"?"inherit":"primary"}  aria-label="add circle" size={"small"}
              component="span" onClick={()=>setModalEdit(true)} style={{justifyContent:"center"}}
            >
              <CreateIcon/>  
            </IconButton>                                                             
          </Tooltip>                                                                                     
          )}    
        {celda("center",{fontWeight:700,width:30+'px'}, 
          <Tooltip title={'Bitácora'}>
            <IconButton color={auxColor==="white"?"inherit":"primary"}  aria-label="add circle" size={"small"}
              component="span" onClick={()=>setModalBitacora(true)} style={{justifyContent:"center"}}
            >
              <FormatListBulletedIcon/>  
            </IconButton>                                                             
          </Tooltip>                                                                                     
          )}    
        {celda("center",{fontWeight:700,width:30+'px'}, 
          row.ImgTotal>0 ?          
          <Tooltip title={'Ver Fotos'}>
            <IconButton color={auxColor==="white"?"inherit":"primary"}  aria-label="add circle" size={"small"}
              component="span" onClick={()=>abrirImg(row)} style={{justifyContent:"center"}}
            >
              <PhotoLibraryIcon/>  
            </IconButton>             
            </Tooltip>                                                                                                                 
        :null)}                                   
        {celda("center", {width:75+'px'},row.Ord)}  
        {celda("center", {width:75+'px'},row.Clase)}  
        {celda("center", {width:130+'px', fontSize: "12px",paddingRight:".5rem"},modificada)}  
        {celda("center", {width:120+'px', fontSize: "12px"},modificada2)}  
        {celda("center", {width:80+'px'},row.RodTVida )}      
        {celda("right", {width:80+'px'}, row.RodHuso )}                  
        {celda("right", {width:80+'px', paddingRight:"10px"},row.RodVuelta )} 
        {celda("left", {width:100+'px', fontSize: "12px"}, row.Tecnico )}                                                                                                    
      </TableRow>
    
    </React.Fragment>
    );
  }

  function tablaCompleta(auxlista){
    //console.log("entrando sin preguntar");
    return(
    <TableContainer className={classes.container}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>                          
        {/*   <TableCell align="center" padding={'none'}>
            {findNumber('|51|') ?  
              <Tooltip title={'Editar'}>
                <IconButton   aria-label="edit List" size="small" 
                  onClick={() => editarList()} component="span"
                >
                  <CreateIcon color="primary"/>
                </IconButton>    
              </Tooltip> 
            : null}
          </TableCell>     */}   
            <TableCell  key={"nvo1"} align={"center"} 
              padding={'none'}
            >
              {}
            </TableCell>  
           <TableCell  key={"nvo1"} align={"center"} 
              padding={'none'}
            >
              {}
            </TableCell>       
             <TableCell  key={"nvo1"} align={"center"} 
              padding={'none'}
            >
              {}
            </TableCell>                 
          {columnas.map((col)=>{
            return <TableCell  key={col.Id} align={col.alineacion} 
              padding={'none'}
            >
              {col.titulo}
            </TableCell> 
          })}                   
        </TableRow>
      </TableHead>
      <TableBody>
        {auxlista.length!==0 ? (auxlista.map((row) => (
          <Row key={row.Id} row={row} />
        ))):null}
      </TableBody>
    </Table>
    </TableContainer>
   )
  }

  const tablaSinDatos=()=>{
   return(<TableContainer className={classes.container2}>
    <Table stickyHeader aria-label="sticky table">
      <TableHead>
        <TableRow>            
        {columnas.map((col)=>{
       return   <TableCell  key={col.Id} align={col.alineacion} 
            padding={'none'}
          >
            {col.titulo}
          </TableCell> 
        })}                                            
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow  className={classes.tableRow} >          
          <TableCell  className={classes.tableCell} align="center" padding={'none'}>
            Dia
          </TableCell>          
          <TableCell  className={classes.tableCell} align="left" padding={'none'}>
            Sin
          </TableCell>             
          <TableCell  className={classes.tableCell} align="left" padding={'none'}>
            Reportes
          </TableCell>                      
        </TableRow>
      </TableBody>
    </Table>
  </TableContainer>
  ) 
  }
  
  const contenido =  datos.length !== 0 ? tablaCompleta(datos) : tablaSinDatos()  
  const modalBit = modalBitacora &&  registro.length!==0? <ModBitacora modalAbierto={modalBitacora} setModalAbierto={setModalBitacora} titulo={`Bitácora ${registro.Clase} ${registro.Ord}`} balancin={registro}  /> :null
  const modalEdt = modalEdit &&  registro.length!==0? <ModEdit modalAbierto={modalEdit} setModalAbierto={setModalEdit}  setDatos={setDatos}
                                                            titulo={`Pilona ${piloRegistro.Folio} - Balancin ${registro.Ord}`} auxRegistro={registro}  datos={datos}
                                                            setAuxRegistro={setRegistro} piloRegistro={piloRegistro} /> :null

  return (
  <Paper className={classes.root}>
    {contenido}
    {modalBit}
    {modalEdt}
    <Backdrop className={classes.backdrop} open={esperaImg} 
      //onClick={()=>setEsperaImg(false)} 
    >
      <CircularProgress color="inherit" />
    </Backdrop>
    <Viewer zIndex={2000}
      visible={verImg} onClose={() => setVerImg(false) }
      images={listImg.map((imagen, index) => {
          return ({src: imagen.Dir+imagen.Archivo, alt: ''})
      })}      
      
    />
  </Paper>
  );
}